import { render } from "./leads-kanban.vue?vue&type=template&id=1ac97a4a"
import script from "./leads-kanban.vue?vue&type=script&lang=js"
export * from "./leads-kanban.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__